// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import SheetLayoutBox from "./sheet-layout-box.js"
import SheetSize from "./sheet-size.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "global": {
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      },
      "name": "global",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "sheet_size_id": {
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_size_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "webshop_name": {
      "column": null,
      "name": "webshop_name",
      "selected_by_default": null,
      "translated": true
    }
  },
  "className": "SheetLayout",
  "collectionKey": "sheet_layouts",
  "collectionName": "sheet_layouts",
  "i18nKey": "sheet_layout",
  "camelizedLower": "sheetLayout",
  "name": "SheetLayout",
  "nameDasherized": "sheet-layout",
  "pluralName": "sheet_layouts",
  "ransackable_associations": [
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_id",
      "name": "boxes",
      "macro": "has_many",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "SheetLayout::Translation",
      "collectionName": null,
      "foreignKey": "sheet_layout_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "sheet_layout_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "PhotoSheetProductSheetLayout",
      "collectionName": "photo_sheet_product_sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "photo_sheet_product_sheet_layouts",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductSheetLayout",
      "through": null
    },
    {
      "className": "PhotoSheetProduct",
      "collectionName": "photo_sheet_products",
      "foreignKey": "sheet_layout_id",
      "name": "photo_sheet_products",
      "macro": "has_many",
      "resource_name": "PhotoSheetProduct",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "SupplierSupportedSheet",
      "collectionName": "supplier_supported_sheets",
      "foreignKey": "sheet_layout_id",
      "name": "supplier_supported_sheets",
      "macro": "has_many",
      "resource_name": "SupplierSupportedSheet",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "SheetLayout::Translation",
      "collectionName": null,
      "foreignKey": "sheet_layout_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "global",
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "sheet_size_id",
      "column": {
        "default": null,
        "name": "sheet_size_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "SheetLayoutBox",
      "collectionName": "sheet_layout_boxes",
      "foreignKey": "sheet_layout_id",
      "name": "boxes",
      "macro": "has_many",
      "resource_name": "SheetLayoutBox",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "belongs_to",
      "resource_name": "SheetSize",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "sheet_layout",
  "primaryKey": "id"
}

/** Frontend model for SheetLayout. */
export default class SheetLayout extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  global() {
    return this.readAttributeUnderscore("global")
  }

  /** @returns {boolean} */
  hasGlobal() {
    const value = this.global()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetSizeId() {
    return this.readAttributeUnderscore("sheet_size_id")
  }

  /** @returns {boolean} */
  hasSheetSizeId() {
    const value = this.sheetSizeId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  webshopName() {
    return this.readAttributeUnderscore("webshop_name")
  }

  /** @returns {boolean} */
  hasWebshopName() {
    const value = this.webshopName()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./sheet-layout-box.js").default>} */
  boxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["sheet_layout_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "boxes",
        model: this,
        modelClass: SheetLayoutBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./sheet-layout-box.js").default>>} */
  loadBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["sheet_layout_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "boxes",
        model: this,
        modelClass: SheetLayoutBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./sheet-layout-box.js").default>>} */
  ensureBoxesLoaded() {
    return this.ensureAssociationLoaded("boxes")
  }

  /** @returns {import("./sheet-size.js").default | null} */
  sheetSize() {
    return this._readBelongsToReflection({modelClass: SheetSize, reflectionName: "sheet_size"})
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  loadSheetSize() {
    if (!("sheetSizeId" in this)) throw new Error("Foreign key method wasn't defined: sheetSizeId")

    const id = this.sheetSizeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_size",
        model: this,
        modelClass: SheetSize
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-size.js").default | null>} */
  ensureSheetSizeLoaded() {
    return this.ensureAssociationLoaded("sheet_size")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
